import React from 'react';
import { FileText, Shield } from 'lucide-react';
export function Footer({
  onNavigate
}: {
  onNavigate: (page: 'terms' | 'privacy') => void;
}) {
  return <footer className="bg-navy-900 py-12 px-4 border-t border-navy-800" data-id="element-311">
      <div className="max-w-4xl mx-auto text-center" data-id="element-312">
        <p className="text-gray-500 text-sm" data-id="element-313">
          © {new Date().getFullYear()} CPAP Compliance Rescue. All rights
          reserved.
        </p>
        <p className="mt-2 text-gray-600 text-sm" data-id="element-314">
          Disclaimer: This guide is for educational purposes only and does not
          constitute medical advice.
        </p>

        <div className="mt-6 flex items-center justify-center gap-6" data-id="element-315">
          <button onClick={() => onNavigate('terms')} className="inline-flex items-center gap-1.5 text-gray-400 hover:text-teal-400 transition-colors text-sm font-medium" data-id="element-316">
            <FileText className="h-3.5 w-3.5" data-id="element-317" />
            Terms of Service
          </button>

          <span className="text-navy-700" data-id="element-318">|</span>

          <button onClick={() => onNavigate('privacy')} className="inline-flex items-center gap-1.5 text-gray-400 hover:text-teal-400 transition-colors text-sm font-medium" data-id="element-319">
            <Shield className="h-3.5 w-3.5" data-id="element-320" />
            Privacy Policy
          </button>
        </div>
      </div>
    </footer>;
}